"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var QwDateEditorials =
/*#__PURE__*/
function () {
  function QwDateEditorials() {
    _classCallCheck(this, QwDateEditorials);
  }

  _createClass(QwDateEditorials, null, [{
    key: "formatMonthYear",

    /**
     * Format output MM/YYYY - example: 06/2018
     * @param {string} date
     * @returns {string | undefined}
     */
    value: function formatMonthYear(date) {
      if (!date) {
        return;
      }

      return "".concat(date.substring(4, 6), "/").concat(date.substring(0, 4));
    }
    /**
     * Format output MM/DD/YYYY - example: 06/15/2018
     * @param {string} date
     * @returns {string | undefined}
     */

  }, {
    key: "formatMonthDayYear",
    value: function formatMonthDayYear(date) {
      if (!date) {
        return;
      }

      return "".concat(date.substring(4, 6), "/").concat(date.substring(6, 8), "/").concat(date.substring(0, 4));
    }
    /**
     * Format output YYYYmmDD - example 20180601
     * @param {string | Date} date
     * @returns {string}
     */

  }, {
    key: "formatRaw",
    value: function formatRaw(date) {
      var newDate = typeof date === 'string' ? new Date(date) : date;
      var day = QwDateEditorials.stringifyElementOfDate(newDate.getDate());
      var month = QwDateEditorials.stringifyElementOfDate(newDate.getMonth() + 1);
      return "".concat(newDate.getFullYear()).concat(month).concat(day);
    }
    /**
     * Get the first and the last day of a date MM/YYYY
     * @param {string} date
     * @returns {{first: string, last: string}}
     */

  }, {
    key: "getFirstAndLastDay",
    value: function getFirstAndLastDay(date) {
      var month = date.substring(0, 2);
      var monthWith30Days = ['04', '06', '09', '11'];
      var lastDay = month === '02' ? '28' : monthWith30Days.includes(month) ? '30' : '31';
      var dateSplitted = date.split('/');
      var first = "".concat(dateSplitted[0], "/01/").concat(dateSplitted[1]);
      var last = "".concat(dateSplitted[0], "/").concat(lastDay, "/").concat(dateSplitted[1]);
      return {
        first: first,
        last: last
      };
    }
    /**
     * @param {number} el
     * @returns {string}
     */

  }, {
    key: "stringifyElementOfDate",
    value: function stringifyElementOfDate(el) {
      return el < 10 ? "0".concat(el) : el.toString();
    }
    /**
     * return an array of string of MM/YYYY from the start one to the end one
     * @param {string} start -> older date
     * @param {string} end -> newer date
     * @returns {string[]}
     */

  }, {
    key: "getRangeOfDates",
    value: function getRangeOfDates(start, end) {
      var startSplitted = start.split('/');
      var endSplitted = end.split('/');
      var startMonth = Number(startSplitted[0]);
      var startYear = Number(startSplitted[1]);
      var endMonth = Number(endSplitted[0]);
      var endYear = Number(endSplitted[1]);

      if (startYear === endYear) {
        return QwDateEditorials._getRangeSameYear(startMonth, endMonth, startYear);
      }

      var rangeStart = QwDateEditorials._getRangeOfMonthsStart(startMonth, startYear);

      var rangeEnd = QwDateEditorials._getRangeOfMonthsEnd(endMonth, endYear);

      var rangeOtherYears = QwDateEditorials._getRangeOtherYears(startYear, endYear);

      return _toConsumableArray(rangeEnd).concat(_toConsumableArray(rangeOtherYears), _toConsumableArray(rangeStart));
    }
  }, {
    key: "_getRangeSameYear",
    value: function _getRangeSameYear(startMonth, endMonth, year) {
      var rangeSameYear = [];

      for (var i = endMonth; i >= startMonth; i--) {
        var month = QwDateEditorials.stringifyElementOfDate(i);
        rangeSameYear.push("".concat(month, "/").concat(year));
      }

      return rangeSameYear;
    }
  }, {
    key: "_getRangeOfMonthsStart",
    value: function _getRangeOfMonthsStart(startMonth, startYear) {
      var rangeOfMonthsStart = [];

      for (var i = 12; i >= startMonth; i--) {
        var month = QwDateEditorials.stringifyElementOfDate(i);
        rangeOfMonthsStart.push("".concat(month, "/").concat(startYear));
      }

      return rangeOfMonthsStart;
    }
  }, {
    key: "_getRangeOfMonthsEnd",
    value: function _getRangeOfMonthsEnd(endMonth, endYear) {
      var rangeOfMonthsEnd = [];

      for (var i = endMonth; i >= 1; i--) {
        var month = QwDateEditorials.stringifyElementOfDate(i);
        rangeOfMonthsEnd.push("".concat(month, "/").concat(endYear));
      }

      return rangeOfMonthsEnd;
    }
  }, {
    key: "_getRangeOtherYears",
    value: function _getRangeOtherYears(startYear, endYear) {
      var otherYears = [];

      for (var i = endYear - 1; i > startYear; i--) {
        otherYears.push(i);
      }

      if (!otherYears.length) {
        return [];
      }

      return otherYears.reduce(function (acc, year) {
        var rangeOfMonths = [];

        for (var _i = 12; _i >= 1; _i--) {
          var month = QwDateEditorials.stringifyElementOfDate(_i);
          rangeOfMonths.push("".concat(month, "/").concat(year));
        }

        return _toConsumableArray(acc).concat(rangeOfMonths);
      }, []);
    }
  }]);

  return QwDateEditorials;
}();

exports.default = QwDateEditorials;



//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/qw-date-editorials/index.js
// module id = 105
// module chunks = 0